var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.featureRollout.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.featureRollout.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      view: {
        path: () => `${ROUTES.featureRollout.view.match.path}`,
        getURL: (featureId, pivot) => {
          const baseUrl = `${this.url}/${featureId}`;
          return !!pivot ? `${baseUrl}/${pivot}` : baseUrl;
        }
      },
      create: {
        path: () => `${ROUTES.featureRollout.create.match.path}`,
        getURL: () => {
          return `${this.url}${ROUTES.featureRollout.create.location.pathname}`;
        }
      },
      edit: {
        path: () => `${ROUTES.featureRollout.edit.match.path}`,
        getURL: (featureId) => {
          return `${this.url}/${featureId}/edit`;
        }
      },
      progressionView: {
        path: () => `${ROUTES.featureRollout.progressionView.match.path}`,
        getURL: (featureId, progressionId) => {
          return `${this.url}/${featureId}${ROUTES.featureRollout.progressionView.location.pathname}/${progressionId}`;
        }
      },
      progressionCreate: {
        path: () => `${ROUTES.featureRollout.progressionCreate.match.path}`,
        getURL: (featureId) => {
          return `${this.url}/${featureId}${ROUTES.featureRollout.progressionCreate.location.pathname}`;
        }
      },
      experientView: {
        path: () => `${ROUTES.featureRollout.experimentView.match.path}`,
        getURL: (featureId, experimentId, pivot) => {
          return `${this.url}/${featureId}${ROUTES.featureRollout.experimentView.location.pathname}/${experimentId}${!!pivot ? `/${pivot}` : ""}`;
        }
      },
      experimentCreate: {
        path: () => `${ROUTES.featureRollout.experimentCreate.match.path}`,
        getURL: (featureId) => {
          return `${this.url}/${featureId}${ROUTES.featureRollout.experimentCreate.location.pathname}`;
        }
      },
      compositionEdit: {
        path: () => `${ROUTES.featureRollout.compositionEdit.match.path}`,
        getURL: (featureId, variantId) => `${this.url}/${featureId}/variants/${variantId}${ROUTES.featureRollout.compositionEdit.location.pathname}`
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const FeatureRolloutRouteUtils = new Util();
export {
  FeatureRolloutRouteUtils
};
//# sourceMappingURL=FeatureRolloutRoute.utils.js.map
